import { TemplateResult, html, CSSResultGroup } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './sic-styled-disclaimer-text.css.lit';
import { wrapLastWord } from '../../../utilities/wrap-last-word';
import { externalLinkText } from '../../../utilities/external-link-text';

wrapLastWord;

/**
 * The Sic Styled Disclaimer Text component
 * @element sic-styled-disclaimer-text
 * @since 1.0.0
 * @slot - default slot
 *
 * Lightdom styles in sic-style-disclaimer-text.lightdom.css included in /shared.css
 */
@customElement('sic-styled-disclaimer-text')
export class SicStyledDisclaimerText extends OutlineElement {
  static styles: CSSResultGroup = [OutlineElement.styles, componentStyles];

  connectedCallback(): void {
    super.connectedCallback();

    this.querySelectorAll('a').forEach(el => {
      // Check if has target="_blank" before adding las-word span.
      if (
        el.getAttribute('target') === '_blank' ||
        el.classList.contains('sic-cta')
      ) {
        // Wraps last word in a span.last-word element.
        // span.last-word is where the icon is added via pseudo
        !el.querySelector('.last-word') && wrapLastWord(el as HTMLElement);

        // Adds external link text for screen readers.
        externalLinkText(el as HTMLElement);
      }
    });
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-styled-disclaimer-text': SicStyledDisclaimerText;
  }
}
